export function resolveApiBaseUrl(): string {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  try {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.hostname}:8000`;
  } catch (error) {
    console.warn('Falling back to localhost:8000 for API base URL', error);
    return 'http://localhost:8000';
  }
}

export const API_BASE_URL = resolveApiBaseUrl();
